import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });
Vue.use(Vuex);

import auth from "./modules/auth";
import users from "./modules/users";
import profile from "./modules/profile";
import recordings from "./modules/recordings";
import payments from "./modules/payments";
import partners from "./modules/partners";
import plans from "./modules/plans";

export default new Vuex.Store({
  modules: {
    auth,
    users,
    profile,
    recordings,
    payments,
    partners,
    plans,
  },
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_NAME,
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
